goog.module('yext.location.Number');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const helpers = goog.require('yext.location.helpers');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');

/**
 * Models a number field like custom number field and year established
 *
 * @constructor
 * @author Yi Liu (yliu@yext.com)
 */
const Number = function($ctx) {
  this.$ctx = $ctx;
  this.$input = $ctx.find('.js-number-field-input');
  this.fieldName = $ctx.find('input[name="field"]').val();

  this.data = {
    value: this.$input.val(),
    indeterminate: $ctx.data('indeterminate'),
  };

  this.storeValue();
  this.bind();

  this.assetOrOriginal = true;
  this.originalValue = this.$input.val();
};

/**
 * Store the value so that it can be restored later
 */
Number.prototype.storeValue = function() {
  this.storedValue = {
    value: this.data.value,
    indeterminate: this.data.indeterminate,
  };
};

/**
 * Bind to the input's change event and publish a custom event
 */
Number.prototype.bind = function() {
  var self = this;

  this.$input.inputchange(function() {
    self.data.value = self.$input.val();
    self.message('updated');
    $(self).trigger('update.struct');
    $(self).trigger('update.list');
    self.updateAssetOrOriginal(false);
  });
};

/**
 * Publish a message with the field as the context
 */
Number.prototype.message = function(msg) {
  $(this).trigger(msg);
};

/**
 * Reset the field to the stored state
 */
Number.prototype.reset = function() {
  this.set(this.storedValue);
};

/**
 * Set the select element value and trigger a change event
 *
 * @param {!Object} field
 */
Number.prototype.set = function(field) {
  this.data.value = field.value;
  this.data.displayValue = field.displayValue;
  this.data.indeterminate = field.indeterminate;
  this.data.displayIndeterminate = field.displayIndeterminate;
  this.render();
};

/**
 * Renders the field in its current state
 */
Number.prototype.render = function() {
  if (this.data.indeterminate) {
    this.$input.val('');
    this.$input.attr('placeholder', yext.msg('Various content'));
  } else if (this.data.value != this.$input.val()) {
    this.$input.val(this.data.value);
    this.message('updated');
    $(this).trigger('update.struct');
  }
};

/**
 * Get the display value of the field (view mode)
 */
Number.prototype.getDisplayValue = function(cannotEdit) {
  if (this.data.displayIndeterminate) {
    return helpers.variousContentMessage();
  } else if (!this.data.displayValue) {
    return helpers.emptyFieldMessage(cannotEdit);
  } else {
    return this.data.displayValue;
  }
};

/**
 * Get the timestamp for the number field
 *
 * @return {string} Timestamp for number field
 */
Number.prototype.getTimestamp = function() {
  return this.$ctx.find('.js-field-timestamp').val();
};

/**
 * Marshal the JSON data for a number field.
 *
 * @return {!Object} data for the field in JSON form
 */
Number.prototype.getJSONData = function() {
  return {
    [this.fieldName + '.value']: this.data.value,
    [this.fieldName + '.timestamp']: this.getTimestamp(),
  };
};

/**
 * Apply values to this field from an asset. Also set the assetOrOriginal flag to true.
 */
Number.prototype.applyAsset = function(fieldValues) {
  this.set(fieldValues);
  this.updateAssetOrOriginal(true);
};


/**
 * Update the asset or original flag.
 */
Number.prototype.updateAssetOrOriginal = function(fromAsset) {
  if (fromAsset || this.originalValue === this.$input.val()) {
    this.assetOrOriginal = true;
  } else {
    this.assetOrOriginal = false;
  }
};

/**
 * Type-ubiquitous function for checking assetOrOriginal flag.
 */
Number.prototype.checkAssetOrOriginalFlag = function() {
  return this.assetOrOriginal;
};

/**
 * The after save function when this number field is a child of a struct.
 */
Number.prototype.setFromStruct = function(fieldValues, $display, $viewTemplate /* unused */, cannotEdit) {
  this.set(fieldValues);
  this.storeValue();
  $display.empty().append(this.getDisplayValue(cannotEdit));

  // reset asset approvals values
  this.assetOrOriginal = true;
  this.originalValue = this.$input.val();
};

/**
 * Clears the field
 */
Number.prototype.clear = function() {
  this.data.value = '';
  this.data.displayValue = '';
  this.data.indeterminate = false;
  this.data.displayIndeterminate = false;
  this.render();
  // reset asset approvals values
  this.updateAssetOrOriginal(false);
};

exports = Number;
